import { createBillingStore } from "./billing.store";
import { createClientsStore } from "./clients.store";
import { createCurrentUserStore } from "./current-user.store";
import { createFeedStore } from "./feed.store";
import { createInvoicesStore } from "./invoices.store";
import { createProjecthoursStore } from "./projecthours.store";
import { createProjectsStore } from "./projects.store";
import { createReportsStore } from "./reports.store";
import { type ApiClientOptions, createApiClient } from "./shared";
import { createTagsStore } from "./tags.store";
import { createTasksStore } from "./tasks.store";
import { createWorkinghoursStore } from "./workinghours.store";
import { createWorkspacesStore } from "./workspaces.store";

export const createTimeghostWebApiStores = (options: ApiClientOptions = {}) => {
	const apiClient = createApiClient(options);

	return {
		api: apiClient,
		billing: createBillingStore(apiClient),
		clients: createClientsStore(apiClient),
		user: createCurrentUserStore(apiClient),
		feed: createFeedStore(apiClient),
		invoices: createInvoicesStore(apiClient),
		projecthours: createProjecthoursStore(apiClient),
		projects: createProjectsStore(apiClient),
		reports: createReportsStore(apiClient),
		tags: createTagsStore(apiClient),
		tasks: createTasksStore(apiClient),
		workinghours: createWorkinghoursStore(apiClient),
		workspaces: createWorkspacesStore(apiClient),
	};
};

export type TimeghostWebApiStores = ReturnType<typeof createTimeghostWebApiStores>;

export {
	type ApplyRealtimeChangeResult,
	applyRealtimeChange,
	EMPTY_APPLY_REALTIME_CHANGE_RESULT,
	normalizeRealtimeChangeType,
	parseRealtimeChangeArgs,
	parseRealtimeChangeMessage,
	type RealtimeChangeMessage,
	RealtimeChangeType,
	type RealtimeChangeTypeValue,
	type RealtimeEntityPayload,
	type RealtimeStores,
	resolveRealtimeEntityName,
} from "./apply-realtime-change";

export type * from "./billing.store";
export type * from "./clients.store";
export type * from "./current-user.store";
export type * from "./feed.store";
export type * from "./invoices.store";
export type * from "./projecthours.store";
export type * from "./projects.store";
export type * from "./reports.store";
export type * from "./tags.store";
export type * from "./tasks.store";
export type * from "./workinghours.store";
export type * from "./workspaces.store";
